export default __webpack_public_path__ + "static/media/Todo_React_Redux_JsonServer.0e8b75aa.png";